import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-slider-config',
  templateUrl: './d-slider-config.component.html',
  styles: []
})
export class DSliderConfigComponent extends DynamicComponentBase {
  static KEY = 'd-slider-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
